import type { IxcProspectusV1ProspectusTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PROSPECTUS_TASK_BASE_PATH = getResolvedPath('/clearing/vendor/beta-nxt/prospectus-task');

export const getProspectusTaskPath: EntityPathBuilder<IxcProspectusV1ProspectusTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PROSPECTUS_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.taskId) {
        return undefined;
      }

      return getResolvedPath(`${PROSPECTUS_TASK_BASE_PATH}/$taskId`, context.keys);
    }
  }
};

export function getProspectusTaskDetailPath(taskId: string | undefined) {
  if (!taskId) {
    return undefined;
  }

  return getProspectusTaskPath({ kind: 'detail', keys: { taskId } });
}
